import React, {useEffect, useState} from 'react';
import {Button, message, Space, Input, Table, Image, Modal, Form, Upload} from "antd";
import http from "../framework/http.js";
import {DeleteOutlined, LoadingOutlined, PlusOutlined} from "@ant-design/icons";
import ReactQuill from "react-quill";

function BlogManagement() {
    const [blogs, setBlogs] = useState();
    const [modalConfirmLoading, setModalConfirmLoading] = useState();
    const [submitMethod, setSubmitMethod] = useState();
    const [deleteButtonLoading, setDeleteButtonLoading] = useState(new Map());
    const [editButtonLoading, setEditButtonLoading] = useState(new Map());
    const [imageUrl, setImageUrl] = useState();
    const [uploading, setUploading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [searchButtonLoading, setSearchButtonLoading] = useState();
    const [form] = Form.useForm();

    useEffect(() => {
        loadBlog();
    }, []);

    async function loadBlog(keyword) {
        const res = await http.get("/blog/list", {params: {keyword: keyword}});
        if (res.data?.code === 200) {
            setBlogs(res.data.data);
        }
    }

    const submitForm = async (formData) => {
        setModalConfirmLoading(true);

        formData.cover = imageUrl;

        if (submitMethod === "insert") {
            await insertBlog(formData)
        } else if (submitMethod === "update") {
            await updateBlog(formData);
        }

        setModalConfirmLoading(false);
    };

    const insertBlog = async (formData) => {
        const res = await http.post("/blog", formData);
        if (res.data?.code === 200) {
            setBlogs([res.data.data, ...blogs]);
            message.success("New record added");
            setModalOpen(false);
            form.resetFields();
            setImageUrl();
        } else if (res.data?.code !== 401) {
            message.error(res.data?.msg || "Error, please try again later");
        }
    };

    const updateBlog = async (formData) => {
        const res = await http.put("/blog", formData);
        if (res.data?.code === 200) {
            setBlogs(blogs.map(item => {
                if (item.id === formData.id) {
                    return res.data.data;
                } else {
                    return item;
                }
            }));

            setModalOpen(false);
            form.resetFields();
            setImageUrl();
            message.success("Record updated");
        } else if (res.data?.code !== 401) {
            message.error(res.data?.msg || "Error, please try again later");
        }
    };

    const onEditClick = async (id) => {
        let newEditButtonLoading = new Map(editButtonLoading);
        newEditButtonLoading.set(id, true);
        setEditButtonLoading(newEditButtonLoading);

        const res = await http.get("/blog/" + id);
        if (res.data?.code === 200) {
            setImageUrl(res.data.data.cover);
            res.data.data.cover = [{
                status: 'done',
                name: res.data.data.cover,
                url: res.data.data.cover
            }]
            form.setFieldsValue(res.data.data);

            await setSubmitMethod("update");
            setModalOpen(true);
        } else if (res.data?.code !== 401) {
            message.error(res.data?.msg || "Error, please try again later");
        }

        newEditButtonLoading = new Map(newEditButtonLoading);
        newEditButtonLoading.delete(id);
        setEditButtonLoading(newEditButtonLoading);
    };

    const onDeleteClick = async (id) => {
        let newDeleteButtonLoading = new Map(deleteButtonLoading);
        newDeleteButtonLoading.set(id, true);
        setDeleteButtonLoading(newDeleteButtonLoading);

        const res = await http.delete("/blog/" + id);
        if (res.data?.code === 200) {
            setBlogs(blogs.filter(o => o.id !== id));
            message.success("Record deleted!");
        } else if (res.data?.code !== 401) {
            message.error(res.data?.msg || "Error, please try again later");
        }

        newDeleteButtonLoading = new Map(newDeleteButtonLoading);
        newDeleteButtonLoading.delete(id);
        setDeleteButtonLoading(newDeleteButtonLoading);
    };

    const beforeUpload = (file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJpgOrPng) {
            message.error('Only JPG/PNG file is accepted');
        } else {
            if (!isLt2M) {
                message.error('Image must smaller than 2MB');
            }
        }
        return isJpgOrPng && isLt2M;
    };

    const handleUploadProcess = (info) => {
        if (info.file.status === 'uploading') {
            setUploading(true);
            return;
        }
        if (info.file.status === 'done') {
            setUploading(false);
            if (info.file.response.data && info.file.response.code === 200) {
                setImageUrl(info.file.response.data.path);
            }
        }
    };

    return (
        <div>
            <Space style={{marginLeft: 10, marginBottom: 10}}>
                <Button type="primary" onClick={async () => {
                    await setSubmitMethod("insert");
                    setModalOpen(true);
                }}>Add</Button>
                <Input.Search
                    placeholder="titme"
                    allowClear
                    enterButton="Search"
                    loading={searchButtonLoading}
                    onSearch={async (value) => {
                        setSearchButtonLoading(true);
                        await loadBlog(value);
                        setSearchButtonLoading(false);
                    }}

                />
            </Space>
            <Table dataSource={blogs} rowKey="id" pagination={{hideOnSinglePage: true}}>
                {/*<Table.Column title="ID" dataIndex="id"/>*/}
                <Table.Column title="Title" dataIndex="title"/>
                <Table.Column title="Cover" dataIndex="cover"
                              render={(src) => (src ? <Image width={50} height={50} src={http.getUri() + src}/> :
                                  <Image width={50} height={50} src={http.getUri() + "images/default.png"}/>)}/>
                <Table.Column title="Created Time" render={(_, record) => {
                    return record.createdTime.replace("T", " ");
                }}/>
                <Table.Column title="Last Modified Time" render={(_, record) => {
                    return record.lastModifiedTime.replace("T", " ");
                }}/>
                <Table.Column width="20%"
                              title="Operation"
                              render={(_, record, index) => (
                                  <Space>
                                      <Button danger
                                              type="primary"
                                              loading={deleteButtonLoading.get(record.id)}
                                              onClick={() => {
                                                  onDeleteClick(record.id);
                                              }}
                                      >Delete</Button>
                                      <Button type="primary"
                                              loading={editButtonLoading.get(record.id)}
                                              onClick={() => {
                                                  onEditClick(record.id);
                                              }}
                                      >Edit</Button>
                                  </Space>
                              )}
                />

            </Table>
            <Modal maskClosable={false} open={modalOpen} onOk={() => {
                form.submit()
            }} confirmLoading={modalConfirmLoading} onCancel={() => {
                setModalOpen(false);
                form.resetFields();
                setImageUrl();
            }}>
                <Form form={form} style={{marginTop: 30}} onFinish={submitForm}>
                    <Form.Item hidden={true} label="Id" name="id">
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="Title"
                        name="title"
                        rules={[
                            {
                                required: true,
                                message: 'This field can not be empty',
                            },
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="Cover"
                        name="cover"
                        valuePropName={"fileList"}
                        getValueFromEvent={(e) => e?.fileList}
                        initialValue={null}
                    >
                        <Upload
                            listType="picture-card"
                            accept=".jpg, .jpeg, .png"
                            showUploadList={false}
                            maxCount={1}
                            action={http.getUri() + "upload"}
                            name="pictureFile" // parameter name
                            data={{foldName: "blog"}}
                            headers={{token: window.localStorage.getItem("token")}}
                            beforeUpload={beforeUpload}
                            onChange={handleUploadProcess}
                        >
                            {imageUrl && !uploading ? (
                                <div style={{position: "relative", width: '100%', height: "100%"}}>
                                    <img src={http.getUri() + imageUrl}
                                         style={{width: '100%', height: "100%", borderRadius: "8%"}} alt=""/>
                                    <DeleteOutlined
                                        style={{
                                            position: "absolute",
                                            left: "110%",
                                            top: "50%",
                                            transform: "translate(0%,-50%)"
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setImageUrl();
                                        }}
                                    />
                                </div>
                            ) : (
                                <div>
                                    {uploading ? <LoadingOutlined/> : <PlusOutlined/>}
                                    <div style={{marginTop: 8,}}>Upload</div>
                                </div>
                            )}
                        </Upload>
                    </Form.Item>
                    <Form.Item
                        label="Content"
                        name="content"
                        rules={[
                            {
                                required: true,
                                message: 'This field can not be empty',
                            },
                        ]}
                    >
                        <ReactQuill
                            theme="snow"
                            modules={{
                                toolbar: [
                                    [{header: [1, 2, 3, false]}],
                                    ['bold', 'italic', 'underline','clean'],
                                    ['link', 'image',{list: 'ordered'}, {list: 'bullet'}],
                                ]
                            }}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default BlogManagement;
